var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiEmotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9716_20396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.918 9.16406C13.6083 9.16406 14.168 8.60442 14.168 7.91406C14.168 7.22371 13.6083 6.66406 12.918 6.66406C12.2276 6.66406 11.668 7.22371 11.668 7.91406C11.668 8.60442 12.2276 9.16406 12.918 9.16406Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08594 9.16406C7.77629 9.16406 8.33594 8.60442 8.33594 7.91406C8.33594 7.22371 7.77629 6.66406 7.08594 6.66406C6.39558 6.66406 5.83594 7.22371 5.83594 7.91406C5.83594 8.60442 6.39558 9.16406 7.08594 9.16406Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 14.9974C11.9026 14.9974 13.5193 13.6141 14.1693 11.6641H5.83594C6.48594 13.6141 8.1026 14.9974 10.0026 14.9974Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99297 1.66406C5.39297 1.66406 1.66797 5.3974 1.66797 9.9974C1.66797 14.5974 5.39297 18.3307 9.99297 18.3307C14.6013 18.3307 18.3346 14.5974 18.3346 9.9974C18.3346 5.3974 14.6013 1.66406 9.99297 1.66406ZM10.0013 16.6641C6.31797 16.6641 3.33464 13.6807 3.33464 9.9974C3.33464 6.31406 6.31797 3.33073 10.0013 3.33073C13.6846 3.33073 16.668 6.31406 16.668 9.9974C16.668 13.6807 13.6846 16.6641 10.0013 16.6641Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9716_20396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiEmotions);
export default __webpack_public_path__ + "static/media/emoji_emotions.b54f206c17fe2511e195de3398fb509c.svg";
export { ForwardRef as ReactComponent };